import * as React from "react";
export const LogoutIconV2 = (props) => (
	<svg
		fill="none"
		height={24}
		viewBox="0 0 24 24"
		width={24}
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M13.6429 16V17.7143C13.6429 18.1689 13.4622 18.6049 13.1408 18.9264C12.8193 19.2479 12.3832 19.4285 11.9286 19.4285H4.21429C3.75963 19.4285 3.32359 19.2479 3.0021 18.9264C2.68061 18.6049 2.5 18.1689 2.5 17.7143V5.71426C2.5 5.2596 2.68061 4.82356 3.0021 4.50207C3.32359 4.18058 3.75963 3.99997 4.21429 3.99997H11.9286C12.3832 3.99997 12.8193 4.18058 13.1408 4.50207C13.4622 4.82356 13.6429 5.2596 13.6429 5.71426V7.42854H11.9286V5.71426H4.21429V17.7143H11.9286V16H13.6429ZM15.7857 6.99997L14.5737 8.21197L17.2189 10.8571H8.5V12.5714H17.2189L14.5737 15.2165L15.7857 16.4285L20.5 11.7143L15.7857 6.99997Z"
			fill="white"
		/>
	</svg>
);
